import { Box, BoxProps, ModalDialog, Spacer } from '@jfs/ui-new'
import { useFocusEffect, useNavigation } from '@react-navigation/native'
import React, { useCallback, useRef, useState } from 'react'
import { ExpandAddView } from '../../components/ExpandAddView'
import { ListNew } from '../../components/ListNew'
import { ModalAlertView } from '../../components/ModalAlertView'
import { useLazyApiData, useStores } from '../../data/store'
import { isAccessible } from '../../utils'
import { ROUTING_PACKAGE_FILETYPE } from '../../utils/constants'
import { EditPackageToMid } from './EditPackageToMid'
import { PackageToMidForm } from './PackageToMidForm'
import { UploadBulkMidToPackage } from './UploadBulkMidToPackage'

const PackageToMId = () => {
  const [isExpand, setIsExpand] = useState(false)
  const [isBulkExpand, setBulkExpand] = useState(false)
  const [isModal, setModal] = useState(false)
  const [data, setData] = useState<any>({})
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false)

  const navigation = useNavigation()
  const { getAll, fetchPackageNames, packageNames, accessConfig, update, deletePackageMId, config, exportFileAsync } =
    useStores((store) => ({
      getAll: store.packageToMId.getAll,
      lenght: store.packageToMId.packageMIds.length,
      fetchPackageNames: store.package.fetchPackageNames,
      update: store.packageToMId.update,
      deletePackageMId: store.packageToMId.deletePackage,
      pnlength: store.package.packageNames.length,
      packageNames: store.package.getPackageNames(),
      config: store.user.accessConfig,
      accessConfig: store.user.getAccessConfig(['routing', 'mid_package_mapping']),
      exportFileAsync: store.exportFileAsync,
    }))

  const [lazyGetAll, { state, data: apiData }] = useLazyApiData(getAll)
  const [lazyUpdate, lazyUpdateHandler] = useLazyApiData(update)
  const [lazyDelete, lazyDeleteHandler] = useLazyApiData(deletePackageMId)
  const [lazyExportFileAsync, exportFileAsyncHandler] = useLazyApiData(exportFileAsync)

  const searchFormRef = React.useRef(null)

  useFocusEffect(
    useCallback(() => {
      if (isAccessible(accessConfig, 'fetch')) {
        lazyGetAll(searchFormRef?.current?.getValues() ?? {}, { page: 1, size: 10 })
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [navigation, config]),
  )

  useFocusEffect(
    useCallback(() => {
      fetchPackageNames()
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [navigation]),
  )

  const keyExtractor = (item: any): string => {
    return item.id
  }

  const headTitles = [{ id: 'ID' }, { mid: 'Mid' }, { packageName: 'Package Name' }, { edit: '' }, { delete: '' }]

  const onEdit = (item: any) => {
    setData(item)
    setModal(true)
  }

  const onDelete = (item: any) => {
    setData(item)
    setIsDeleteModalVisible(true)
  }
  const fetchDataFromServer = useCallback(
    (data, paginationInfo) => {
      lazyGetAll(data, paginationInfo)
    },
    [lazyGetAll],
  )
  console.log('htag data', apiData?.content)
  const abortControllerRef = useRef<AbortController>()
  const getAbortController = () => {
    abortControllerRef.current = new AbortController()
    return abortControllerRef.current
  }
  const exportFile = () => {
    lazyExportFileAsync(
      { ...(searchFormRef?.current?.getValues() ?? {}), fileType: '0' },
      'PACKAGE_MID_MAPPING_LIST',
      undefined,
      getAbortController,
    )
  }

  const getMappingList = () => {
    return (
      <Box>
        <ListNew
          searchFormRef={searchFormRef}
          searchData={SEARCH_FILTERS as any}
          data={apiData?.content}
          updatedPaginationInfo={{
            ...(apiData?.pageNo !== undefined && { page: apiData?.pageNo }),
            ...(apiData?.totalElements !== undefined && {
              total: apiData?.totalElements,
            }),
          }}
          isSearchButtonLoading={state === ('pending' as any)}
          apiHandler={{ state, apiData } as any}
          fetchDataFromServer={fetchDataFromServer}
          keyExtractor={keyExtractor}
          headTitle={headTitles}
          sizeConfig={[2, 4, 4, 2, 2]}
          onEdit={onEdit}
          onDelete={onDelete}
          listTitle={'Mapping List'}
          onRowItemClick={undefined}
          exportFile={exportFile}
          isExportButtonLoading={exportFileAsyncHandler.state === 'pending'}
        />
      </Box>
    )
  }

  const handleUpdate = (value: any) => {
    lazyUpdate({
      id: data?.item?.id,
      mid: data?.item?.mid,
      packageName: value,
      fileType: ROUTING_PACKAGE_FILETYPE,
    })
    setModal(false)
  }

  const handleDelete = () => {
    lazyDelete({
      id: data?.item?.id,
      mid: data?.item?.mid,
      packageName: data?.item?.packageName,
      fileType: ROUTING_PACKAGE_FILETYPE,
    })
    setIsDeleteModalVisible(false)
  }

  const onAdd = () => {
    setData({})
    setModal(true)
  }

  const onUpdate = () => {
    setModal(false)
    setIsExpand(false)
  }

  const renderModal = () => {
    if (!isModal) {
      return <></>
    }
    return (
      <EditPackageToMid
        packageName={data?.item?.packageName}
        update={handleUpdate}
        close={() => setModal(false)}
        packageNames={packageNames}
      />
    )
  }
  return (
    <Box>
      {isAccessible(accessConfig, 'add') && (
        <>
          <ExpandAddView
            children={
              <PackageToMidForm
                data={data}
                packageNames={packageNames}
                onUpdate={onUpdate}
                isDeletable={isAccessible(accessConfig, 'delete')}
                isEditable={isAccessible(accessConfig, 'update')}
                onClose={() => setModal(false)}
              />
            }
            title={'Package to MID Mapping'}
            isExpand={isExpand}
            setIsExpand={setIsExpand}
          />
          <Spacer direction="vertical" size={20} />

          <ExpandAddView title={'Bulk Package to MID Mapping'} isExpand={isBulkExpand} setIsExpand={setBulkExpand}>
            <UploadBulkMidToPackage />
          </ExpandAddView>
        </>
      )}
      <Spacer direction="vertical" size={16} />
      {isAccessible(accessConfig, 'fetch') && getMappingList()}
      <ModalDialog show={isModal} children={renderModal()} type={'Centered'} />
      <ModalAlertView
        show={isDeleteModalVisible}
        onDismiss={() => setIsDeleteModalVisible(false)}
        title="Delete Rule Package"
        message={`Is this final. This will raise request in approvals to delete package[${data?.item?.packageName}] merchantId[${data?.item?.mid}]`}
        onPress={handleDelete}
        onCancel={() => setIsDeleteModalVisible(false)}
        buttonTitle="Delete"
      />
    </Box>
  )
}

export default PackageToMId

const shadow = {
  shadowColor: '#000',
  shadowOffset: {
    width: 1,
    height: 1,
  },
  shadowOpacity: 0.1,
  shadowRadius: 4,
  zIndex: 10,
}

const styles = {
  container: {
    ...shadow,
    backgroundColor: 'WHITE',
    underlayColor: 'WHITE',
  } as BoxProps,
  innerContainer: {
    backgroundColor: 'WHITE',
    underlayColor: 'WHITE',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 16,
  } as BoxProps,
  listContainer: {
    ...shadow,
    backgroundColor: 'WHITE',
    padding: 16,
    underlayColor: 'WHITE',
  } as BoxProps,
}

const SEARCH_FILTERS = [
  [
    { key: 'id', type: 'string', placeHolder: 'ID' },
    { key: 'mid', type: 'string', placeHolder: ' Merchant Id' },
    { key: 'packageName', type: 'string', placeHolder: 'Package Name' },
  ],
]
